import React from "react"
import classNames, {Argument} from "classnames"

interface FieldProps {
    label: React.ReactNode
    children: React.ReactNode
    classes?: Argument[]
    labelStyles?: React.CSSProperties
    valueStyles?: React.CSSProperties
    labelClasses?: Argument[]
    valueClasses?: Argument[]
    isRequired?: boolean
}

export default function Field({
                                  label,
                                  children,
                                  labelStyles,
                                  valueStyles,
                                  labelClasses = [],
                                  classes = [],
                                  valueClasses = [],
                                  isRequired
                              }: FieldProps) {

    return (
        <div className={classNames("field", ...classes)}>
            <div className={classNames("name", ...labelClasses)} style={labelStyles}>
                {label} {isRequired && <span style={{color: "var(--red)"}}>*</span>}
            </div>
            <div className={classNames("value", ...valueClasses)} style={valueStyles}>
                {children}
            </div>
        </div>
    )
};